<template>
  <svg
    v-bind="$attrs"
    :width="width"
    :height="height"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.72011 1.18788C9.00648 1.18673 10.2643 1.55788 11.3344 2.25439C12.4046 2.95089 13.239 3.94144 13.7321 5.10074C14.2251 6.26003 14.3548 7.53598 14.1045 8.76717C13.8543 9.99837 13.2354 11.1295 12.3263 12.0174C11.4171 12.9054 10.2584 13.5102 8.99685 13.7555C7.73529 14.0008 6.42751 13.8755 5.23895 13.3955C4.05039 12.9154 3.03445 12.1021 2.31966 11.0586C1.60487 10.015 1.22334 8.78805 1.22334 7.53288C1.23114 5.85343 1.91794 4.24484 3.13446 3.05674C4.35099 1.86863 5.99892 1.19702 7.72011 1.18788ZM7.72011 0C6.19322 0 4.70061 0.441796 3.43105 1.26952C2.16148 2.09724 1.17198 3.27372 0.587662 4.65017C0.00334511 6.02663 -0.149539 7.54124 0.148343 9.00247C0.446225 10.4637 1.18149 11.8059 2.26117 12.8594C3.34085 13.9129 4.71644 14.6304 6.21399 14.921C7.71155 15.2117 9.2638 15.0625 10.6745 14.4924C12.0851 13.9222 13.2909 12.9567 14.1391 11.7179C14.9874 10.4791 15.4402 9.02275 15.4402 7.53288C15.4402 5.53504 14.6269 3.61902 13.1791 2.20633C11.7313 0.793641 9.76761 0 7.72011 0Z"
      :fill="fill"
    />
    <path
      d="M18.8074 17.5515L14.8391 13.6532C14.6119 13.43 14.2482 13.4288 14.0195 13.6504C13.7826 13.8799 13.7813 14.2594 14.0165 14.4906L17.9641 18.3685C18.0191 18.4225 18.0844 18.4655 18.1564 18.4949C18.2284 18.5242 18.3056 18.5395 18.3836 18.5398C18.4617 18.54 18.539 18.5253 18.6112 18.4964C18.6834 18.4675 18.749 18.4251 18.8044 18.3714C18.8598 18.3178 18.9038 18.254 18.9339 18.1838C18.964 18.1135 18.9797 18.0382 18.9799 17.9621C18.9802 17.8859 18.9651 17.8105 18.9355 17.74C18.9059 17.6696 18.8624 17.6055 18.8074 17.5515Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
const props = defineProps({
  width: {
    type: [String, Number],
    default: 19,
  },
  height: {
    type: [String, Number],
    default: 19,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>